/** URL `?tab=` values for site visit overview. */
export const EnquirySiteVisitOverviewTabParam = {
  OVERVIEW: "overview",
  ATTACHMENTS: "attachments",
  CHECKLIST: "checklist",
} as const;

export type EnquirySiteVisitOverviewTabParamValue =
  (typeof EnquirySiteVisitOverviewTabParam)[keyof typeof EnquirySiteVisitOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, EnquirySiteVisitOverviewTabParamValue> = {
  "1": EnquirySiteVisitOverviewTabParam.OVERVIEW,
  "2": EnquirySiteVisitOverviewTabParam.ATTACHMENTS,
  "3": EnquirySiteVisitOverviewTabParam.CHECKLIST,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [EnquirySiteVisitOverviewTabParam.OVERVIEW]: "1",
  [EnquirySiteVisitOverviewTabParam.ATTACHMENTS]: "2",
  [EnquirySiteVisitOverviewTabParam.CHECKLIST]: "3",
};

export function enquirySiteVisitOverviewTabIdFromSearchParam(
  tab: string | null,
): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForEnquirySiteVisitOverviewTabId(
  tabId: string,
): EnquirySiteVisitOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidEnquirySiteVisitOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
